import { Box, Card, CardContent, Typography, Grid, Stack } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { styled } from "@mui/material/styles";
import logo1 from "./img/whatappSuccessImg1.jpg";
import logo2 from "./img/whatsappSuccessImg2.jpg";
import logo3 from "./img/WhatsAppSuccess3.jpg";

// Sample data for cards
const cardData = [
  {
    image: logo1,
    headline:
      "Farmonaut achieved 100% ROI after implementing Ads that Click to WhatsApp",
    description:
      "Farmonaut, a satellite-based crop health monitoring company, was able to drive these results with Ads that Click to WhatsApp:",
    points: [
      "₹10 Avg. Cost Per Lead",
      "₹80 Avg. Cost Per Conversion",
      "15% Surcharge in Conversion",
      "100% ROI Since Implementation",
    ],
  },
  {
    image: logo2,
    headline:
      "The 1% Club increased Conversion Rate by 3X with Ads that Click to WhatsApp",
    description:
      "The 1% Club, a SOCIAL FINANCE APP by Mr. Sharan Hegde experienced a massive growth in their marketing performance with Ads that Click to WhatsApp:",
    points: ["5X Increase in Leads", "3X Increase in Conversion Rate"],
  },
  {
    image: logo3,
    headline:
      "FliQi grew it’s REVENUE by 70-80% by running Ads that Click to WhatsApp",
    description:
      "FliQi, INDIA’S first education marketplace for competitive learning used AISENSY’S Ads that Click to WhatsApp solution to reach more qualified leads:",
    points: ["85% Conversion of Qualified Leads", "70-80% Revenue Growth"],
  },
];

// Styled Card with glassmorphism
const GlassCard = styled(Card)(({ theme }) => ({
  height: "100%",
  color: "#fff",
  background: "rgba(255, 255, 255, 0.1)",
  backdropFilter: "blur(10px)",
  border: "1px solid rgba(255, 255, 255, 0.2)",
  borderRadius: "16px",
  boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
  transition: "transform 0.3s ease-in-out",
  display: "flex",
  flexDirection: "column",
  "&:hover": {
    transform: "translateY(-8px)",
  },
  [theme.breakpoints.down("sm")]: {
    margin: theme.spacing(1),
  },
}));

const TitleTypography = styled(Typography)(({ theme }) => ({
  color: "#fff",
  fontWeight: "bold",
  fontSize: "2.5rem",
  letterSpacing: "0.05em",
  [theme.breakpoints.down("md")]: {
    fontSize: "2rem",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "1.5rem",
  },
}));

const HighlightTypography = styled(Typography)(({ theme }) => ({
  color: "#00C853",
  fontWeight: "bold",
  fontSize: "2.5rem",
  display: "inline",
  letterSpacing: "0.05em",
  [theme.breakpoints.down("md")]: {
    fontSize: "2rem",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "1.5rem",
  },
}));

const WhatsAppSuccess = () => {
  return (
    <Box
      sx={{
        backgroundImage: `url('bg3.svg')`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        display: "flex",
        justifyContent: "center",
        minHeight: "80vh",
      }}
    >
      <Box
        sx={{
          py: { xs: 4, md: 8 },
          width: { xl: "74%", lg: "79%", md: "90%", sm: "95%", xs: "95%" },
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            mb: 4,
          }}
        >
          <TitleTypography variant="h1" component="span">
            Ads that Click to{" "}
            <HighlightTypography component="span">
              WhatsApp Success Stories
            </HighlightTypography>
          </TitleTypography>
        </Box>

        <Grid
          container
          spacing={{ xs: 2, md: 4 }}
          justifyContent="center"
          mb={4}
        >
          {cardData.map((card, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <GlassCard>
                <CardContent
                  sx={{
                    p: { xs: 2, md: 3 },
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box mb={2}>
                    <img
                      src={card.image}
                      alt={card.headline}
                      height={60}
                      width={60}
                      style={{ objectFit: "contain" }}
                    />
                  </Box>
                  <Typography
                    variant="h5"
                    gutterBottom
                    sx={{
                      fontWeight: "medium",
                      fontSize: { xs: "1.2rem", md: "1.5rem" },
                    }}
                    mb={2}
                  >
                    {card.headline}
                  </Typography>
                  <Typography
                    color="rgba(255, 255, 255, 0.67)"
                    fontSize={{ xs: 12, sm: 14, md: 16 }}
                    mb={2}
                    sx={{ flexGrow: 1 }}
                  >
                    {card.description}
                  </Typography>
                  <Box>
                    {card.points.map((point, idx) => (
                      <Stack
                        key={idx}
                        direction="row"
                        alignItems="center"
                        spacing={1.2}
                        mb={1}
                      >
                        <CheckCircleIcon
                          sx={{
                            color: "#00C853",
                            fontSize: { xs: 18, md: 22 },
                          }}
                        />
                        <Typography
                          sx={{
                            fontWeight: 500,
                            fontSize: { xs: "0.9rem", md: "1.05rem" },
                          }}
                        >
                          {point}
                        </Typography>
                      </Stack>
                    ))}
                  </Box>
                </CardContent>
              </GlassCard>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default WhatsAppSuccess;
